/** True when the API reports that the meter does not exist in WaterScope Classic. */
export function isClassicMeterNotFound(error: unknown): boolean {
  const { status, body } = (error ?? {}) as {
    status?: number;
    body?: { error?: { code?: string } };
  };
  return status === 404 && body?.error?.code === 'CLASSIC_METER_NOT_FOUND';
}

/**
 * Retry only failures that may be transient: network errors (no HTTP status)
 * and 5xx. A 4xx, including 401 and the Classic-not-found 404, is a
 * definitive answer.
 */
export function isRetryableApiError(error: unknown): boolean {
  const status = (error as { status?: unknown } | null)?.status;
  return typeof status !== 'number' || status >= 500;
}
